import React from 'react';
import PropTypes from 'prop-types';

import { Chart as ChartJS } from 'chart.js/auto';
import { Chart, Bar, Line } from 'react-chartjs-2';

import {
  Banner,
  ContentBody,
  Gallery,
  OurTeam,
  SplitBanner,
  SplitBannerContent,
  SplitBannerImage,
  SplitBannerVideo,
  slugify,
} from '@lanl-web/lanl-components';

import {
  getImageUrl,
  replaceElements,
  //   replaceElements,
  //   LGLink,
  //   getImageSrcSet,
} from '../../utils';
import { RawDataTable } from '../RawDataTable';
import { LinksTable } from '../LinksTable';
import { Video } from '../Video';
// import { replaceElements } from '../../../../../shared/utils';
// import { getTeamData } from '../shapeData';

// import './AllSections.scss';

/**
 * @typedef {object} Intro
 * @property {string} [title]
 * @property {string} [subtitle]
 * @property {string} [intro_body]
 */

/**
 *
 * @param {number} index
 * @param {Partial<Queries.DirectusData_lg_pages_sections>} section
 */

const renderSection = (index, section, intro) => {
  switch (section?.collection) {
    case 'wm_body':
      return renderContentBody(section.item, index);
    case 'wm_charts':
      return renderChart(section.item, index);
    case 'wm_chart_summary':
      return renderChartSummaries(section.item, index);
    case 'wm_data_request':
      return renderRawDataTable(section.item, index);
    case 'wm_video':
      return renderVideo(section.item, index);
    default:
      break;
  }
};

export const renderContentBody = (sectionItem, index) => {
  const title = sectionItem?.title;
  const linkSectionId = sectionItem?.link_section_id ?? null;
  const isLinkable = !!linkSectionId;

  return (
    <section
      className='mt-2'
      style={{ backgroundColor: 'white' }}
      key={`wm-body-${index}`}
    >
      {title && <h2>{title}</h2>}
      <ContentBody
        id={linkSectionId}
        body={replaceElements(sectionItem?.content ?? '')}
        className='wm-body'
        linkSectionId={linkSectionId}
        isLinkable={isLinkable}
      />
    </section>
  );
};

export const renderChart = (sectionItem, index) => {
  const name = sectionItem?.name;
  const type = sectionItem?.chart_type;
  const labels = sectionItem?.labels?.split(',') ?? [];
  const dataSet = sectionItem?.data ?? [];
  const mappedDataSet = dataSet.map(({ Label, Color, Variable }) => ({
    label: Label,
    backgroundColor: Color,
    data: labels.map((label, index) =>
      Math.floor(Math.random() * (100 - 10 + 1) + 10),
    ),
  }));

  const options = {
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  const data = {
    labels: labels,
    datasets: mappedDataSet,
  };

  switch (type) {
    case 'bar':
      return (
        <Bar
          style={{ margin: '2rem 0' }}
          datasetIdKey={`${slugify(name)}-${index}`}
          data={data}
          options={options}
          key={`wm-chart-${index}`}
        />
      );
    case 'line':
      return (
        <Line
          style={{ margin: '2rem 0' }}
          datasetIdKey={`${slugify(name)}-${index}`}
          data={data}
          options={options}
          key={`wm-chart-${index}`}
        />
      );
    default:
      break;
  }
};

const renderChartSummaries = (sectionItem, index) => {
  const description = sectionItem?.description;
  const title = sectionItem?.title;
  const chartResources = sectionItem?.chart_resources ?? [];

  return (
    <LinksTable
      key={`wm-chart-summaries-${index}`}
      description={description ?? ''}
      title={title ?? ''}
      resources={chartResources}
    />
  );
};

const renderRawDataTable = (sectionItem, index) => {
  return <RawDataTable key={`wm-data-request-${index}`} />;
};

const renderVideo = (sectionItem, index) => {
  const videoId = sectionItem?.video_id;
  const title = sectionItem?.title;
  const sectionTitle = sectionItem?.section_title;

  return (
    <Video
      key={`wm-video-${index}`}
      videoId={videoId}
      title={title}
      sectionTitle={sectionTitle}
    />
  );
};

/**
 * @param {object} props
 * @param {object[]} [props.data]
 */
export const AllSections = ({ data }) => {
  return <>{data.map((section, index) => renderSection(index, section))}</>;
};

AllSections.defaultProps = {
  intro: {},
  podcasts: [],
  publications: [],
  stories: [],
};

AllSections.propTypes = {
  data: PropTypes.array.isRequired,
  intro: PropTypes.object,
  podcasts: PropTypes.array,
  publications: PropTypes.array,
  stories: PropTypes.array,
};

export default AllSections;
